module.exports = __webpack_public_path__ + "./ChingYa_99592132855b9679340f45d2535d2424.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2021/ChingYa.jpg
// module id = 522
// module chunks = 0